// @flow
import React from 'react';
import access from 'safe-access';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import Select from 'react-select';

import { operatorValueToLabel } from '../../utils/rules';
import ControlWrapper from '../controls/ControlWrapper';
import { actions } from 'react-redux-form';

// Selectors
const selectProject = (state, props) => state.projects[props.params.projectKey];

const getTargets = createSelector(
  selectProject,
  project => project.targets
);

const getSelectedTarget = createSelector(
  (state, props) => props.baseModel,
  (state) => state.form.rules,
  (baseModel, rulesForm) => access(rulesForm, `${baseModel}.target`)
);

const getTarget = createSelector(
  getTargets,
  getSelectedTarget,
  (targets, key) => targets.filter(target => target.key === key)[0]
);

// Operator options by target type
const OPERATOR_OPTIONS = {
  segment: ['in', 'notIn'],
  string: ['contains', 'equals', 'startsWith', 'endsWith', 'matches', 'in', 'notIn'],
  date: ['before', 'after'],
  number: ['equals', 'greaterThan', 'greaterThanOrEqual', 'lessThan', 'lessThanOrEqual']
};

// Component
const OperatorSelector = ({ target }) => {
  const options = target ? OPERATOR_OPTIONS[target.type] || [] : [];

  return (
    <div style={{ flex: 1, marginRight: 8 }}>
      <ControlWrapper
        model=".operator"
        placeholder="Matches"
        component={Select}
        validateOn={['blur', 'change']}
        ignore={['blur']}
        disabled={!target}
        errorMessages={{ isRequired: 'Required' }}
        clearable={false}
        changeAction={(model = '', value = {}) => {
          return dispatch => {
            const conditionModel = model.substr(0, model.lastIndexOf('.'));
            dispatch(actions.merge(conditionModel, {
              operator: value.value
            }));
          };
        }}
        options={options.map(opt => ({
          label: operatorValueToLabel(opt),
          value: opt
        }))}
      />
    </div>
  );
};

const mapStateToProps = (state, props) => ({
  target: getTarget(state, props)
});

export default withRouter(connect(mapStateToProps)(OperatorSelector));